export default {
    find:   { method: 'get',    url: 'countries' },
    create: { method: 'post',   url: 'countries'},
    update: { method: 'put',    url: 'countries/{id}'},
    delete: { method: 'delete', url: 'countries/{id}'}
}